module.exports = __webpack_public_path__ + "img/yezi5.51050780.png";